"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const PredicateLabelText_1 = require("../wizards/AutomatedDelivery/EventTrigger/PredicateLabelText");
const DevicePredicateLabel = ({ predicate, textStyle }) => {
    const style = Object.assign(Object.assign(Object.assign(Object.assign({}, src_1.text), src_1.regular), { lineHeight: '24px', height: 24 }), textStyle);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { style: style },
            predicate.keyPath,
            "\u00A0"),
        React.createElement("span", { style: Object.assign(Object.assign({}, style), { fontStyle: 'italic', color: src_1.graphite }) },
            predicate.operator.toLowerCase().replace('_', ' '),
            "\u00A0"),
        React.createElement(PredicateLabelText_1.default, { predicate: predicate })));
};
exports.default = React.memo(DevicePredicateLabel);
